const publicPages = [
  '/',
  '/about',
  '/affiliates',
  '/agency-plans',
  '/api-docs',
  '/charge',
  '/contact',
  '/enterprise',
  '/features',
  '/forgot',
  '/index.html',
  '/legal',
  '/list-of-nsfw-subreddits',
  '/login',
  '/logout',
  '/plans',
  '/privacy',
  '/wrapped',
  '/safety-letter',
  '/signin',
  '/signup',
  '/terms'
]

const publicPathPrefixes = [
  '/analysis',
  '/blog',
  '/compare',
  '/confirm-email',
  '/connect',
  '/features',
  '/help',
  '/integrations',
  '/join',
  '/legal',
  '/multi-social',
  '/platforms',
  '/subreddit-lists',
  '/r',
  '/redditors',
  '/reset-password',
  '/solutions',
  '/use-cases'
]

const publicPagesWithAppendedSlash = publicPages.map((path) => (path += '/'))

export function isRoutePublic(route) {
  const routePath =
    typeof route === 'string' ? route : route.path ? route.path : route.url

  const isPublicPage =
    publicPages.includes(routePath) ||
    publicPagesWithAppendedSlash.includes(routePath)

  const isPublicPrefix = publicPathPrefixes.some((prefix) =>
    routePath.startsWith(prefix)
  )

  const routePublic = isPublicPage || isPublicPrefix

  return routePublic
}
